import { useEffect, useMemo, useRef } from "react";
import { ChatbotStyle } from "./schema";

export function usePrevious<T>(value: T) {
  // Copied from https://usehooks.com/usePrevious/

  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<T>();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export function useBlockDisplayStyle(style?: ChatbotStyle) {
  return useMemo(() => {
    const DEFAULT_HEIGHTS = {
      maxHeight: "calc(100vh - 130px)",
      height: "initial",
    };

    if (style?.height === "custom") {
      if (!style?.heightValue) {
        return DEFAULT_HEIGHTS;
      }

      return {
        maxHeight: `${style.heightValue}px`,
        height: `${style.heightValue}px`,
      };
    }

    return DEFAULT_HEIGHTS;
  }, [style?.heightValue, style?.height]);
}
